import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PendingSummaryPage } from '@/features/dashboards/pages/PendingSummaryPage';
import { pendingSummarySearchSchema } from '@/features/dashboards/types/pendingSummary.types';

export const Route = createFileRoute('/_auth/dashboards/pending')({
  validateSearch: pendingSummarySearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR & DER Pending">
      <Suspense fallback={<PageLoader />}>
        <PendingSummaryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
